import { SimpleForm } from 'react-admin';
import { CreateStyled } from '@/styles/overrides';
import FormContent from './FormContent';
import { ConnectReportProps } from './types';

const ConnectReport = ({ onClose, record, worker, ...props }: ConnectReportProps) => {
  return (
    <CreateStyled title="Connect Report" {...props}>
      <SimpleForm mode="onChange" reValidateMode="onChange" toolbar={false}>
        <FormContent onClose={onClose} record={record} worker={worker} />
      </SimpleForm>
    </CreateStyled>
  );
};

export default ConnectReport;
